import React, { useState } from 'react';
import { Row, Col, Input, Button, Form } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import logodark from '../../assets/images/logo-dark.png';
import logolight from '../../assets/images/logo-light.png';
import { BASE_URL } from '../../components/Common/AppConfig';
import SetAlert from '../../components/Common/SetAlert';
import { setUserId, setUserRole, setUserName, setO_photo} from '../../store/Role/action';

import { useDispatch } from 'react-redux';
const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [alertMessage, setAlertMessage] = useState({ success: '', error: '' }); // Define the alertMessage state here

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();


  const handleSubmit = async (values) => {

    try {
      const response = await fetch(`${BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      if (data.status && data.data.jwtToken) {
        setIsLoggedIn(true);
        const sessionToken = data.data.jwtToken;
        dispatch(setUserRole(data.data.role));
        dispatch(setUserId(data.data.userId));
        dispatch(setUserName(data.data.fullName));
        dispatch(setO_photo(data.data.u_photo));
        const sessionExpiration = new Date().getTime() + 5000 * 60 * 5000;
        sessionStorage.setItem('sessionToken', sessionToken);
        sessionStorage.setItem('sessionExpiration', sessionExpiration);
        history.push('/dashboard');
      } else {
        setAlertMessage({ success: '', error: data.error || 'Invalid credentials' });
        setIsLoggedIn(false);
      }
    } catch (error) {
      console.error('API Error:', error);

      setIsLoggedIn(false);
      setAlertMessage({ success: '', error: 'Invalid credentials' });
    }
  };

    return (
        <React.Fragment>
            <div>
                <div className="p-0">
                    <Row className="g-0">
                    <Col xs={0} lg={12}>
                            <div className="authentication-bg">
                                <div className="bg-overlay"></div>
                            </div>
                        </Col>
                        <Col xs={24} lg={12} style={{background:"#ffffff"}}>
                            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                <div className="w-100">
                                    <Row className="justify-content-center">
                                        <Col lg={18}>
                                            <div>
                                                <div className="text-center mt-6">
                                                    <div>
                                                        <Link to="/" className="">
                                                         <img src={logodark} alt="" height="100" className="auth-logo logo-dark mx-auto" />

                                                        </Link>
                                                    </div>

                                                    <h4 className="font-size-18 mt-4">Jay Swaminarayan !</h4>
                                                        </div>

                                                <SetAlert alertMessage={alertMessage} setAlertMessage={setAlertMessage} />

                                                <div className="p-2 mt-5">
                                                    <Form className="form-horizontal" onFinish={handleSubmit}>
                                                        <div className="auth-form-group-custom mb-4">
                                                            <i className="ri-user-2-line auti-custom-input-icon"></i>
                                                            <label htmlFor="email">Email</label>
                                                            <Form.Item
                                                                name="email"
                                                                rules={[
                                                                    { required: true, message: 'Please enter your email' },
                                                                    { type: 'email', message: 'Please enter a valid email' },
                                                                ]}
                                                                initialValue={email}
                                                            >
                                                                <Input onChange={(e) => setEmail(e.target.value)} type="text" className="form-control" id="email" placeholder="Enter Email" />
                                                            </Form.Item>
                                                        </div>

                                                        <div className="auth-form-group-custom mb-4">
                                                            <i className="ri-lock-2-line auti-custom-input-icon"></i>
                                                            <label htmlFor="userpassword">Password</label>
                                                            <Form.Item
                                                                name="password"
                                                                rules={[{ required: true, message: 'Please enter your password' }]}
                                                                initialValue={password}
                                                            >
                                                                <Input onChange={(e) => setPassword(e.target.value)} type="password" className="form-control" id="userpassword" placeholder="Enter password" />
                                                            </Form.Item>
                                                        </div>



                                                        <div className="mt-4 text-center">
                                                            <Button type="primary" htmlType="submit" className="w-md waves-effect waves-light">Log In</Button>
                                                        </div>


                                                    </Form>
                                                </div>

                                                <div className="mt-5 text-center" style={{bottom:'0'}}>
                                                    <p> © {new Date().getFullYear()}  CodeLaksh. </p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>

                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Login;
